module.exports = __webpack_public_path__ + "static/media/noData.22ab8b16.png";